export enum ProductionTimeOptionEnum {
    WORKING_PLAN_TIME= 'WORKING_PLAN_TIME',
    TIME_REGISTRATION = 'TIME_REGISTRATION',
}
